import React from "react";
import { HeaderSeiteType, PageType } from "../../utils/baseTypes";
import { motion, useAnimationControls } from "framer-motion";
import dynamic from "next/dynamic";

const HeaderAnimationPalyer = dynamic(() => import("./HeaderDotPlayer"), {
  loading: () => <></>,
  ssr: false,
});

interface HeaderAnimationProps {
  post: PageType;
  isSinglePage: boolean;
}

export const HeaderAnimation = ({
  post,
  isSinglePage,
}: HeaderAnimationProps) => {
  const header = post.acf?.header_seite as HeaderSeiteType;
  const bg_control = useAnimationControls();
  const { header_height } = header;

  return (
    <motion.section
      id={"header-animation"}
      animate={bg_control}
      className={`animationslider section ${header_height} ${
        isSinglePage ? "is-single-page" : ""
      }`}
    >
      <HeaderAnimationPalyer bg_control={bg_control} post={post} />
    </motion.section>
  );
};
